import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

/** Angular error key -> i18n key. Keys all exist in assets/i18n/en.json. */
const ERROR_TEXT_KEYS: { [errorKey: string]: string } = {
  max: "MAX_INPUT",
  maxlength: "MAX_LENGTH_INPUT",
  min: "MIN_INPUT",
  minlength: "MIN_LENGTH_INPUT",
  required: "REQUIRED_INPUT",
};

@Component({
  selector: "radio-group-with-input",
  templateUrl: "radio-group-with-input.component.html",
})
export class RadioGroupWithInputComponent {
  // Inputs
  @Input() formGroup: FormGroup;
  @Input() isReadOnly: boolean = false;
  @Input() layout: "horizontal" | "vertical" = "horizontal";
  @Input() options: Array<{ value: string; label: string }>;
  @Input() radioControlName: string;
  @Input() radioLabel: string;
  // OPTIONAL: Other Input
  @Input() otherControlName?: string;
  @Input() otherLabel?: string = "other";
  @Input() otherPlaceholder?: string = "other";
  @Input() otherMaxLength?: number = 100;
  // OPTIONAL: Comment Text Area
  @Input() commentControlName?: string;
  @Input() commentLabel?: string;
  @Input() commentMaxLength?: number = 6000;
  @Input() commentRows?: number = 4;

  // Instance Variables
  private showCommentTextArea: boolean = false;
  private showOtherInput: boolean = false;

  ngOnInit(): void {
    // Initialize the radio control with an empty string if it doesn't have a value
    const radioControl = this.formGroup.get(this.radioControlName);
    if (radioControl && !radioControl.value) {
      radioControl.setValue("");
    }

    this.showOtherInput = this.shouldShowOtherInput();
    this.showCommentTextArea = this.shouldShowCommentTextArea();
  }

  private shouldShowCommentTextArea(): boolean {
    return !!(this.commentControlName && this.commentLabel);
  }

  private shouldShowOtherInput(): boolean {
    return !!(
      this.otherControlName &&
      this.otherLabel &&
      this.otherPlaceholder
    );
  }

  /**
   * Renders unconditionally on invalidity (no touched/dirty gate) — a value
   * loaded from the server can be invalid before the user touches anything,
   * which is exactly how SUP-20043 produced a dead Save button with no reason
   * shown. Mirrors date-time-field, whose showValidation defaults to true.
   */
  hasVisibleError(controlName: string): boolean {
    const control = this.formGroup && this.formGroup.get(controlName);
    return !!control && control.invalid && !control.disabled;
  }

  errorTextFor(controlName: string): string {
    const control = this.formGroup && this.formGroup.get(controlName);
    if (!control || !control.errors) {
      return "";
    }
    const keys = Object.keys(control.errors);
    for (let i = 0; i < keys.length; i++) {
      if (ERROR_TEXT_KEYS[keys[i]]) {
        return ERROR_TEXT_KEYS[keys[i]];
      }
    }
    // An unmapped validator still gets a truthful message rather than silence:
    // saying nothing is what made SUP-20043 undiagnosable in the first place.
    return "error";
  }
}



// WEBPACK FOOTER //
// ./src/components/radio-group-with-input/radio-group-with-input.component.ts